import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Icons } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable } from 'rxjs';
import {
    ACCOUNT_NUMBER_MAX_LENGTH,
    ROUTING_NUMBER_LENGTH
} from '../../../constants/bank.constants';
import { AddBankAccountFormService } from './add-bank-account-form.service';

@Component({
    selector: 'add-bank-account-form',
    styleUrls: ['./add-bank-account-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="add-bank-account-form" *ngIf="addBankAccountFormGroup$ | async">
            <form [formGroup]="addBankAccountFormGroup$ | async" class="banking-info-form row">
                <div class="col-12">
                    <lsq-input
                        formControlName="accountName"
                        [name]="'account-name'"
                        [group]="addBankAccountFormGroup$ | async"
                        i18n-label="Bank account name input"
                        label="Exact Name of Account"
                    >
                    </lsq-input>
                </div>
                <div class="col-md-6">
                    <lsq-input
                        formControlName="accountNumber"
                        [name]="'account-number'"
                        [group]="addBankAccountFormGroup$ | async"
                        i18n-label="Bank account number input"
                        label="Account Number"
                        [maxLength]="accountNumberMaxLength"
                        [noPaste]="true"
                        [digitsOnly]="true"
                        [type]="'number'"
                    >
                    </lsq-input>
                </div>
                <div class="col-md-6">
                    <lsq-input
                        formControlName="verifyAccountNumber"
                        [name]="'verify-account-number'"
                        [group]="addBankAccountFormGroup$ | async"
                        i18n-label="Bank account number verify input"
                        label="Verify Account Number"
                        [maxLength]="accountNumberMaxLength"
                        [noPaste]="true"
                        [type]="'number'"
                        [digitsOnly]="true"
                    >
                    </lsq-input>
                </div>
                <div class="col-md-6">
                    <lsq-input
                        formControlName="routingNumber"
                        [name]="'routing-number'"
                        [group]="addBankAccountFormGroup$ | async"
                        i18n-label="Bank account routing number input"
                        label="ABA / Routing Number"
                        [maxLength]="routingNumberMaxLength"
                        [type]="'number'"
                        [digitsOnly]="true"
                    >
                    </lsq-input>
                </div>
                <div class="col-md-6">
                    <lsq-input
                        formControlName="bankName"
                        [name]="'bank-name'"
                        [group]="addBankAccountFormGroup$ | async"
                        i18n-label="Bank name input"
                        label="Bank Name"
                    >
                    </lsq-input>
                </div>
                <ng-container>
                    <div class="col-12 payment-verification-message">
                        <span i18n="Payment Method verification message">
                            {{ description }}
                        </span>
                        <br />
                        <span class="bold">
                            {{ fileDescription }}
                        </span>
                    </div>
                    <div class="col-12">
                        <lsq-file-picker
                            [placeholderText]="filePickerPlaceholderText"
                            [hideRemoveButton]="
                                (addBankAccountFormService.fileUpload$ | async)?.uploadHasStarted
                            "
                            [uploadErrorMessage]="
                                addBankAccountFormService.uploadErrorMessage$ | async
                            "
                            [fileUpload]="addBankAccountFormService.fileUpload$ | async"
                            (fileSourceValueChanged)="
                                addBankAccountFormService.handleFileSelected($event)
                            "
                            (fileSourceElementChanged)="
                                addBankAccountFormService.setFileSource($event)
                            "
                        >
                        </lsq-file-picker>
                    </div>
                </ng-container>
            </form>
        </div>
    `
})
export class AddBankAccountFormComponent implements OnInit {
    public description = this._i18n(
        "We'll need to verify this account before we can send early payments to it. Please provide us one of the following documents:"
    );

    public addBankAccountFormGroup$: Observable<FormGroup>;
    public readonly icons = Icons;
    public readonly accountNumberMaxLength = ACCOUNT_NUMBER_MAX_LENGTH;
    public readonly routingNumberMaxLength = ROUTING_NUMBER_LENGTH;
    public readonly filePickerPlaceholderText = this._i18n('Attach Document');
    public readonly fileDescription = this._i18n(
        'Voided Check / Bank Account Statement / Bank Letter'
    );

    constructor(public addBankAccountFormService: AddBankAccountFormService, private _i18n: I18n) {}

    public ngOnInit(): void {
        this.addBankAccountFormService.resetFileSelected();
        this.addBankAccountFormGroup$ = this.addBankAccountFormService.formGroup$;
    }
}
